import {html, LitElement, PropertyValues} from 'lit';
import {customElement} from 'lit/decorators';
import {AccordionItem} from '@webs/components-library/accordion-item';

@customElement('webs-accordion')
export class Accordion extends LitElement {

  protected render(): unknown {
    return html`
      <slot></slot>`;
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    document.addEventListener('DOMContentLoaded', evt => {
      const items = this.shadowRoot.querySelector('slot').assignedElements();
      const accordionItems: AccordionItem[] = items.filter(value => value instanceof AccordionItem) as AccordionItem[];

      for (const item of accordionItems) {
        item.addEventListener('click', ev => {
          if (!item.isOpen) {
            this.close(accordionItems.filter(value => value !== item));
          }

          item.isOpen = !item.isOpen;
          item.requestUpdate();
        });
      }
    });
  }

  private close(items: AccordionItem[]): void {
    for (const item of items) {
      item.isOpen = false;
      item.requestUpdate();
    }
  }
}
